import { ulid } from "@/schemas/commonFields";
import { z } from "@/zod";

const storeProjectAssignee = z.object({
  id: ulid,
  store_id: ulid,
  store_ref_number: z.string(),
  store_name: z.string(),
  project_id: ulid,
  project_ref_number: z.string(),
  project_name: z.string(),
  user_id: ulid,
  user_ref_number: z.string(),
  user_name: z.string(),
  user_role_code: z.string(),
  user_role_name: z.string(),
  is_primary: z.boolean(),
});

export const storeProjectAssigneeListItem = storeProjectAssignee
  .omit({
    user_role_code: true,
  })
  .readonly();

export const readStoreProjectAssignee = storeProjectAssignee.readonly();

export const storeProjectAssigneeCreate = z.object({
  project_id: ulid,
  store_ids: z.array(ulid),
  is_primary: z.boolean(),
  user_id: ulid,
});

export const storeProjectAssigneeCreateForm = z.object({
  project_id: z.string().min(1),
  is_primary: z.boolean(),
  user_id: ulid,
  selectedSystemRoleCodes: z.array(z.string()).optional(),
});

export const storeProjectAssigneeCreateResponse =
  storeProjectAssigneeCreate.extend({
    id: ulid,
  });

export const storeProjectAssigneeUpdate = z.object({
  store_id: ulid,
  project_id: ulid,
  is_primary: z.boolean(),
  user_id: ulid,
  selectedSystemRoleCodes: z.array(z.string()).optional(),
});

export const storeProjectAssigneeUpdateResponse = storeProjectAssigneeListItem;
